import type { FindUseADTObject } from '@lighthouse/shared'
import { createContext, useContext } from 'react'

/** findUse Context */
export type FindUseConfigure = { open: boolean; config?: FindUseADTObject }
const FindUseContext = createContext<FindUseConfigure & { onChange?: (val: FindUseConfigure) => void }>({
    open: false
})
export const FindUseProvider = FindUseContext.Provider
export const useFindUseContext = () => useContext(FindUseContext)

/** 根页面id */
const RootPageContext = createContext<{ refreshRootPage?: () => void }>({})
export const RootPageProvider = RootPageContext.Provider
export const useRootPageContext = () => useContext(RootPageContext)

/** 当前页面id */
const PageContext = createContext<{ pageId: string; refreshPage?: () => void; refreshPageData?: () => void }>({
    pageId: ''
})
export const PageProvider = PageContext.Provider
export const useCurrentPageContext = () => useContext(PageContext)

/** 当前stack id */
const PageStackContext = createContext<string>('')
export const PageStackProvider = PageStackContext.Provider
export const useCurrentStackIdContext = () => useContext(PageStackContext)
